const inquiry = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    name: '',
    kana: '',
    charge_name: '',
    department: '',
    postnumber: '',
    address: '',
    address2: '',
    address3: '',
    address4: '',
    email: '',
    email_check: '',
    occupation_classification: '',
    occupation: '',
    tel: '',
    tel2: '',
    extension: '',
    fax: '',
    message_type: '', // お問い合わせタイプ(お問い合わせで使用)
    message: '', // お問い合わせメッセージ(お問い合わせで使用)
    introducer: '', // 紹介者
    note: '', // 備考（お見積もり、無料トライアル）
    productsLicenses: [], // 選択した商品＆ライセンス数のリスト
    selectedProductIds: [], // 選択した商品IDリスト
    agreement_id: '', // 契約ID（確認画面の無料トライアル・見積り＆お問い合わせ登録APIから取得し、完了画面の選択パッケージ＆ライセンス情報一覧APIに渡す）
    occupationClassificationList: [], // 選択肢(プルダウン)生成用リスト
    isAddressAreaVisible: false // 住所エリア表示フラグ（デフォルトfalse）
  },
  getters: {
  },
  mutations: {
    setFormInputValues(state, payload) {
      state.name = payload.name 
      state.kana = payload.kana
      state.charge_name = payload.charge_name
      state.department = payload.department
      state.postnumber = payload.postnumber
      state.address = payload.address
      state.address2 = payload.address2
      state.address3 = payload.address3
      state.address4 = payload.address4
      state.email = payload.email
      state.email_check = payload.email_check
      state.occupation_classification = payload.occupation_classification
      state.occupation = payload.occupation
      state.tel = payload.tel
      state.tel2 = payload.tel2
      state.extension = payload.extension
      state.fax = payload.fax
      state.message_type = payload.message_type
      state.message = payload.message
      state.introducer = payload.introducer
      state.note = payload.note
      state.radioPaymentMethod = payload.radioPaymentMethod
      state.productsLicenses = payload.productsLicenses // 選択した商品＆ライセンス数のリスト
      state.selectedProductIds = payload.selectedProductIds // 選択した商品IDリスト
      state.occupationClassificationList = payload.occupationClassificationList // 選択肢(プルダウン)生成用リスト
    },
    setAgreementId(state, agreementId) {
      state.agreement_id = agreementId
    },
    clearAllStates(state) {
      state.name = ''
      state.kana = ''
      state.charge_name = ''
      state.department = ''
      state.postnumber = ''
      state.address = ''
      state.address2 = ''
      state.address3 = ''
      state.address4 = ''
      state.email = ''
      state.email_check = ''
      state.occupation_classification = ''
      state.occupation = ''
      state.tel = ''
      state.tel2 = ''
      state.extension = ''
      state.fax = ''
      state.message_type = ''
      state.message = ''
      state.introducer = ''
      state.note = ''
      state.radioPaymentMethod = 1
      state.productsLicenses = []
      state.selectedProductIds = []
      state.agreement_id = ''
      state.occupationClassificationList = [] // 選択肢(プルダウン)生成用リスト
      state.isAddressAreaVisible = false
    },
    setAddressAreaVisible(state, isAddressAreaVisible) {
      state.isAddressAreaVisible = isAddressAreaVisible
    },
    setValue(state, { key, value }) {
      state[key] = value
    }
  },
  actions: {
    /**
     * フォームに入力した値を設定する
     */
    setFormInputValues({ commit }, params) {
      commit('setFormInputValues', params)
    },
    /**
     * 契約IDを設定する
     */
    setAgreementId({ commit }, agreementId) {
      commit('setAgreementId', agreementId)
    },
    /**
     * ストアに保持している値を全クリア
     */
    clearAllStates({ commit }) {
      commit('clearAllStates')
    },
    /**
     * 住所エリア表示状態を設定
     */
    setAddressAreaVisible({ commit }, isAddressAreaVisible) {
      commit('setAddressAreaVisible', isAddressAreaVisible)
    },
    /**
     * パラメータ名を指定して値を更新する
     * @param {string} キー（パラメータ名）
     * @param {*} 値
     */
    setValue({ commit }, { key, value }) {
      commit('setValue', { key, value })
    }
  }
}

export default inquiry
